export class TenantTag {
  id?: string;
  title: string = '';
  description?: string;
  createdAt: Date = new Date();
}
